import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FilterOption } from '../../../layout/types/layout-state.type';
import { CLUSTER_CODES } from '../../client/helpers';
import { sizeByClassificationSelector } from '../../selectors/cluster.selectors';
import { filterOptionSelector } from '../../../layout/selectors/layout.selectors';
import { updateClusterFilterOption } from '../../thunks/update-cluster-filter-option.thunk';
import { Tabs, TabList, Tab } from '@cdl/heartbeat-react';

const FILTER: FilterOption[] = ['All', ...Object.values(CLUSTER_CODES)];

export const FilterClassifications: React.FC = () => {
  const dispatch = useDispatch();
  const classificationSizes = useSelector(sizeByClassificationSelector);
  const filterOption = useSelector(filterOptionSelector);
  const onClickClassification = useCallback(
    (option: FilterOption) => {
      dispatch(updateClusterFilterOption(option));
    },
    [dispatch],
  );

  const FilterButtons = useMemo(
    () =>
      FILTER.map((clusterType) => (
        <Tab
          key={clusterType}
          data-testid='filter-classification'
          onClick={() => onClickClassification(clusterType)}
          color='neutral.0'
        >
          {`${clusterType} (${classificationSizes[clusterType]})`}
        </Tab>
      )),
    [classificationSizes, onClickClassification],
  );
  return (
    <Tabs
      variant='solid-rounded'
      display='flex'
      margin='auto'
      index={FILTER.indexOf(filterOption)}
    >
      <TabList>{FilterButtons}</TabList>
    </Tabs>
  );
};
